import { practiceTestQuestions as gaQuestions, Question } from './practiceTestQuestions';
import { practiceTestQuestions as flQuestions } from './practiceTestQuestions.fl';
import { practiceTestQuestions as caQuestions } from './practiceTestQuestions.ca';
import { practiceTestQuestions as txQuestions } from './practiceTestQuestions.tx';
import { practiceTestQuestions as nyQuestions } from './practiceTestQuestions.ny';
import { practiceTestQuestions as njQuestions } from './practiceTestQuestions.nj';

export type StateCode = 'ga' | 'fl' | 'ca' | 'tx' | 'ny' | 'nj' | string;

/** NY uses a 300-question bank; 75 are randomly selected per session. */
export const NY_QUESTION_BANK_SIZE = 300;
export const NY_QUESTIONS_PER_SESSION = 75;

/** NJ uses a 450-question bank; 75 are randomly selected per session. */
export const NJ_QUESTION_BANK_SIZE = 450;
export const NJ_QUESTIONS_PER_SESSION = 75;

export function getPracticeTestQuestions(state: StateCode = 'ga'): Question[] {
  switch (state) {
    case 'fl':
      return flQuestions;
    case 'ca':
      return caQuestions;
    case 'tx':
      return txQuestions;
    case 'ny':
      return nyQuestions;
    case 'nj':
      return njQuestions;
    case 'ga':
    default:
      return gaQuestions;
  }
}


